<template>
    <div class="flex w-full gap-5 h-full users-view justify-content-around overflow-hidden">
        <div class="section-table w-full">
            <div class="flex justify-content-between align-items-center">
                <h2 class="page-header">{{ $t('message.user.header') }}</h2>
                <CustomButton :label="$t('message.user.addNewButton')" @click="addNewUser" />
            </div>
            <UserTable ref="userTable" v-model="selectedUser" @showForm="showForm" />
        </div>
        <LibyanOrnament/>
        <div id="scrollToForm" class="section-details">
            <div class="flex justify-content-between align-items-center pr-1">
                <h2 class="page-header">{{ createMode ? $t('message.user.headerNew') : $t('message.user.headerEdit') }}</h2>
                <CustomIconButton icon="pi pi-times" onlyIcon @click="hideForm" class="close-form-button" />
            </div>
            <UserForm :selectedUser="selectedUser" @change-element="reloadTable"
                      @createMode="(val) => createMode = val" @hideForm="hideForm" />
        </div>
    </div>
</template>

<script>
    import UserTable from "./components/UserTable";
    import UserForm from "./components/UserForm.vue";
    import CustomButton from "@/components/form/CustomButton.vue";
    import { ScrollToUtils } from "@/utils/ScrollToUtils";
    import LibyanOrnament from "@/components/LibyanOrnament.vue";
    import CustomIconButton from "@/components/form/CustomIconButton.vue";
    import { ShowHideFormUtils } from "@/utils/ShowHideFormUtils";

    export default {
        name: "UserListView",
        components: {
            LibyanOrnament,
            UserTable,
            UserForm,
            CustomButton,
            CustomIconButton,

        },

        data() {
            return {
                selectedUser: {},
                createMode: true,
            };
        },

        mounted() {
            this.selectedUser = this.getClearUser();
        },

        methods: {
            getClearUser() {
                return {
                    id: null,
                    fullName: "",
                    email: "",
                    systemRole: null,
                    whichLab: null,
                };
            },
            reloadTable() {
                this.$refs.userTable.reloadTable();
                this.selectedUser = this.getClearUser();
            },
            addNewUser() {
                ScrollToUtils.scrollToElement();
                this.$refs.userTable.addNewUser();
                this.selectedUser = this.getClearUser();
                this.showForm();
            },
            showForm() {
                ShowHideFormUtils.showHideVertical(".section-table", ".section-details");
            },
            hideForm() {
                ShowHideFormUtils.showHideVertical(".section-table", ".section-details", true);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/theme/mytheme/variables";
    .users-view {
        @media screen and (max-width: 1200px) {
            flex-direction: column;
            align-items: center;
            .section-table, .section-details {
                width: 90% !important;
                overflow-y: unset;
                height: fit-content;
            }
            .close-form-button {
                display: none;
            }
        }
    }
    .section-table, .section-details {
        transition: 1s ease-in-out;
    }
    .section-details {
        height: calc(100vh - 40px - $top-bar-height);;
        overflow-y: auto;
        width: 0;
    }
</style>
